import React, { useContext } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { AuthContext, PaycheckContext } from "../../../../contexts";

const HealthCardAlert = () => {
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);

	const planName = paycheck
		? paycheck.employee_class === "FT - Full Time"
			? "Health Plan"
			: paycheck.employee_class === "PT - Part Time"
			? "Clinic Card"
			: paycheck.employee_class === "PTIN - Part Time Insurance Eligible"
			? "Health Plan or Clinic Card"
			: "Health Plan"
		: "Health Plan";

	return (
		<div className="health-card-alert-container">
			<Alert
				severity="error"
				style={{
					backgroundColor: "#ffd6d6",
					// opacity: "0.9",
					margin: "3% 35%",
					padding: "1rem",
					height: "5.5rem",
					borderRadius: "0.8rem",
					boxShadow: "0px 0px 5px red",
					fontSize: "1rem"
				}}
			>
				<AlertTitle>
					<strong>Caution!</strong>
				</AlertTitle>
				<div>
					You are currently not enrolled to a <strong>{planName}</strong>
				</div>
			</Alert>
		</div>
	);
};

export default HealthCardAlert;
